<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h4 class="panel-title">
        <a class="accordion-toggle" data-toggle="collapse" v-bind:href="randomAcountHref(item.userId)" aria-expanded="true">
          <i class="ace-icon fa fa-angle-down bigger-110" data-icon-hide="ace-icon fa fa-angle-down" data-icon-show="ace-icon fa fa-angle-right"></i>
          &nbsp;アカウント
        </a>
      </h4>
    </div>
    <div class="panel-collapse collapse in" :id="randomAcountClass(item.userId)">
      <div class="panel-body">
        <div class="profile-user-info profile-user-info-striped">
          <div class="profile-info-row">
            <div class="profile-info-name">ユーザーID</div>
            <div class="profile-info-value">
              <span>{{item.userId}}</span>
            </div>
          </div>
          <div class="profile-info-row">
            <div class="profile-info-name">ユーザー名/ふりがな</div>
            <div class="profile-info-value">
              <span class="editable">{{item.name}}/{{item.furigana}}</span>
            </div>
          </div>
          <div class="profile-info-row">
            <div class="profile-info-name">メールアドレス</div>
            <div class="profile-info-value">
              <span>{{item.email}}</span>
            </div>
          </div>
          <div class="profile-info-row">
            <div class="profile-info-name">組織管理権限</div>
            <div class="profile-info-value">
              <span v-if="item.isAdmin">管理者</span>
              <span v-else >ユーザー</span>
            </div>
          </div>
          <div class="profile-info-row">
            <div class="profile-info-name">ゲート設定権限</div>
            <div class="profile-info-value">
              <span v-if="item.isPhoneAdmin">有効</span>
              <span v-else >無効</span>
            </div>
          </div>
          <div class="profile-info-row">
            <div class="profile-info-name">鍵共有権限</div>
            <div class="profile-info-value">
              <span v-if="item.shareKeyBeValid">有効</span>
              <span v-else >無効</span>
            </div>
          </div>
          <div class="profile-info-row">
            <div class="profile-info-name">ステータス</div>
            <div class="profile-info-value">
              <span v-if="item.isValid">有効</span>
              <span v-else >無効</span>
            </div>
          </div>
          <div class="profile-info-row">
            <div class="profile-info-name">SMS認証</div>
            <div class="profile-info-value">
              <span v-if="item.isMfaSms">有効</span>
              <span v-else >無効</span>
            </div>
          </div>
          <div class="profile-info-row">
            <div class="profile-info-name">電話番号</div>
            <div class="profile-info-value">
              <span>{{item.phoneNumber.replace('+81', '0')}}</span>
            </div>
          </div>
          <div class="profile-info-row">
            <div class="profile-info-name">備考.1</div>
            <div class="profile-info-value">
              <span>{{item.option1}}</span>
            </div>
          </div>
          <div class="profile-info-row">
            <div class="profile-info-name">備考.2</div>
            <div class="profile-info-value">
              <span>{{item.option2}}</span>
            </div>
          </div>
          <div class="profile-info-row">
            <div class="profile-info-name">登録日 - 更新日</div>
            <div class="profile-info-value">
              {{ converDateShort(item.registered) }} - {{ converDateShort(item.updated) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: ['item'],
  data () {
    return {
      phoneNumber: ''
    }
  },
  methods: {
    removeSpecialSymboy (text) {
      return text.replace(/[^a-z0-9\s]/gi, '-').replace(/[_\s]/g, '-')
    },
    randomAcountClass (classname) {
      return 'acount' + this.removeSpecialSymboy(classname)
    },
    randomAcountHref (classname) {
      return '#acount' + this.removeSpecialSymboy(classname)
    },
    converDateShort (t) {
      return moment(new Date(t * 1000)).format('YYYY/MM/DD')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/UserDetailAccount.vue